import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TRANSLATE_FILE_ACCEPT } from '../constants';

const ACCEPTED_EXTENSIONS = TRANSLATE_FILE_ACCEPT.split(',');

const getFileExtension = (fileName: string): string => {
  const index = fileName.lastIndexOf('.');
  return index >= 0 ? fileName.slice(index).toLowerCase() : '';
};

export function useTranslateFile() {
  const { t } = useTranslation();
  const [file, setFile] = useState<File | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const selectFile = useCallback(
    (nextFile: File | null): boolean => {
      if (!nextFile) return false;

      if (!ACCEPTED_EXTENSIONS.includes(getFileExtension(nextFile.name))) {
        setErrorMessage(t('translate.errors.unsupportedFile'));
        return false;
      }

      setErrorMessage(null);
      setFile(nextFile);
      return true;
    },
    [t]
  );

  const clearFile = useCallback(() => {
    setFile(null);
    setErrorMessage(null);
  }, []);

  const clearError = useCallback(() => {
    setErrorMessage(null);
  }, []);

  return {
    file,
    errorMessage,
    selectFile,
    clearFile,
    clearError,
  };
}
